import React from 'react';
import useHomePath from 'hooks/useHomePath';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from '@mui/material';
import { StyledBody, StyledError } from './styles';

function NotFoundPage() {
  const homePath = useHomePath();
  return (
    <div>
      <StyledError>
        <StyledBody>
          <p className="error">404</p>
          <p className="error-title">Oops!! page not found</p>
          <p className="c-text">
            The page you are looking for might have been removed, had its name
            changed or is temporarily unavailable
          </p>
          <Button size="large" component={Link} to={homePath} variant="contained">
            Home page
          </Button>
        </StyledBody>
      </StyledError>
    </div>
  );
}

export default NotFoundPage;
